import React, { useState, useEffect } from "react"
import s from "./PartnersArea.module.css"
import { useNavigate } from "react-router"
import ImageBanner from "../components/ImageBanner"
import content from "../data/pageContent.json"
import Header from "../components/Header"
import { DownloadTable } from "../components/DownloadTable"
import Footer from "../components/Footer"
import { checkValidToken, generateToken } from "../functions/requests"
import { message } from "antd"

const PartnersArea = () => {
  const navigate = useNavigate()
  const page = content["partners-area"]
  const [token, setToken] = useState(null)

  useEffect(() => {
    console.log("run", window.location.href)
    const handleAuthentication = async () => {
      // Check for existing Login --------------------------------
      const tempToken = localStorage.getItem("token")

      if (tempToken !== null) {
        const res = await checkValidToken(tempToken)
        // Remove if no longer valid
        if (!res.ok) {
          localStorage.removeItem("token")
          navigate("/partners-area/login")
          return
        }
        setToken(tempToken)
        message.success("Welcome back to the partners area!")
        return
      }

      // Handle New Login -------------------------------------
      let userDetails = null
      userDetails = checkUrlParamsForUser()
      // Redirect to login if no user details found
      if (!userDetails) {
        localStorage.removeItem("token")
        navigate("/partners-area/login")
        return
      }

      // Generate New Token -------------------------------------
      const tokenResponse = await generateToken(
        userDetails.userId,
        userDetails.token,
      )
      console.log({ tokenResponse })
      if (!tokenResponse.ok) {
        localStorage.removeItem("token")
        message.error(
          "Failed to generate token. Please login again to access the partners area.",
        )
        navigate("/partners-area/login")
        return
      }
      const tokenDetails = await tokenResponse.json()
      console.log(tokenDetails)
      localStorage.setItem("token", tokenDetails.auth_token)
      setToken(tokenDetails.auth_token)
    }

    handleAuthentication()
  }, [])

  const checkUrlParamsForUser = () => {
    const params = new URLSearchParams(window.location.search)
    const userId = params.get("id")
    const tempToken = params.get("token")
    if (!userId || !tempToken) return null
    return { userId, token: tempToken }
  }

  return (
    <>
      <main>
        <ImageBanner
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
          image={page.image}
        />
        <Header
          image={page.image}
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
        ></Header>
        <div className={"body"}>
          <div className={"body-container"}>
            <DownloadTable token={token} />
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default PartnersArea
